import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    anchor: String,
    iframeSrc: String
  }

  connect() {
    if (window.location.hash === `#${this.anchorValue}`) {
      this.open()
    }

    document.addEventListener('click', event => {
      if (event.target.matches(`a[href="#${this.anchorValue}"]`)) {
        this.open(event)
      }
    })
  }

  disconnect() {
    $(this.element).modal('hide')
  }

  open(event = null) {
    if (event) event.preventDefault()

    this.element.querySelector(
      '.modal-body'
    ).innerHTML = `<iframe src="${this.iframeSrcValue}" frameborder="0" style="width: 100%; min-height: 480px"></iframe>`
    $(this.element).modal('show')
  }
}
